import { RootState } from 'common/redux/core/root.reducer';
import { store } from 'common/redux/core/store.config';

export const getUploadModalVisibility = (state: RootState) => state.masterData.isUploadModalVisible;

export const getMasterDataSelector = (state: RootState) => state.masterData.masterData;

export const getMasterDataValue = (state: RootState) =>
    state.masterData.masterData.data?.data || [];

export const getMode = (state: RootState) => state.masterData.mode;

export const getFieldErrors = (state: RootState) => state.masterData.fieldErrors;

export const getPreviewDataDetails = (state: RootState) => state.masterData.previewDetails;

export const getPreviewDataDetailsApiStatus = (state: RootState) =>
    state.masterData.previewDetailsAPIStatus;

export const getEditModalVisibility = (state: RootState) => state.masterData.isEditModalVisible;

export const getSearchList = (state: RootState) => state.masterData.searchList.data?.data || [];
export const getSearchListStatus = (state: RootState) => state.masterData.searchList.status;
export const getSearchListPagination = (state: RootState) =>
    state.masterData.searchList.data?.pagination;

export const getAddModalVisibility = (state: RootState) => state.masterData.isAddModalVisible;

export const getAddCategoryError = (state: RootState) => state.masterData.addedData.status;

export const getMessageBanner = (state: RootState) => state.masterData.messageBanner;

export const getHierarchicalDataSelector = (state: RootState) =>
    state.masterData.hierarchicalData.data?.data || [];

export const getHierarchicalDataResponse = (state: RootState) => state.masterData.hierarchicalData;

export const getEntityDetailsResponse = (state: RootState) => state.masterData.entityDetails;

export const getSelectedVariantsArray = (state: RootState) =>
    state.masterData.selectedVariantsArray;

export const getSubCategoryForEdit = (state: RootState) => state.masterData.editSubCategory.data;

export const getReviewStatus = (state: RootState) => state.masterData.reviewStatus.data;

export const getLinkIndicatorStatus = (state: RootState) => state.masterData.linkIndicator;

export const getCurrentMasterData = () => {
    return store.getState().masterData.masterData.data?.data || [];
};

export const getScrollToTopFlag = (state: RootState) => state.masterData.gridScrollToTop;

export const getDeleteFeasibility = (state: RootState) => state.masterData.deleteFeasibility;

export const getArchiveFeasibility = (state: RootState) => state.masterData.archiveFeasibility;

export const getSubcategoryExistWithSameName = (state: RootState) =>
    state.masterData.childSubCategoryData.data;

export const getIsMovableSubCategoryResponse = (state: RootState) =>
    state.masterData.isMovableSubCategory;

export const getIndicatorCopyResponse = (state: RootState) => state.masterData.copyIndicator;

export const getCloneFeasibility = (state: RootState) => state.masterData.cloneFeasibility;

export const getDuplicateIndicatorResponse = (state: RootState) =>
    state.masterData.isDuplicateIndicator;
